import { useState } from 'react';

import { Button, Form, Input } from 'antd';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { setVisibleCU02902 } from 'presentation/redux/features/CU/CU02902Slice';
import {
    completeFetching,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { ModalRegisterProperty } from './Components/ModalRegisterPorperty';
import { ListedPropertyInquiresCreate } from './models';

interface props {
    propertyUseCase: PropertyUseCaseInterface;
}

const LIST_CONTENT_POPUP = [
    '物件登録完了後',
    'メッセージにて回答いたします。',
    '今しばらくお待ちください。',
];

const CU02902Page = ({ propertyUseCase }: props) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();

    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const navigate = useNavigate();

    const showConfirmModal = (value: any) => {
        const modalProps = commonHelpers.getConfirmProps('P011', {
            returnValue: value,
            onOk: (retVal: any) => {
                submit(retVal);
            },
        });
        dispatch(showConfirm(modalProps));
    };

    const submit = async (value: any) => {
        try {
            dispatch(startFetching());
            const data: ListedPropertyInquiresCreate = {
                propertyName: value.propertyName,
                residence: value.residence,
                inquiryDatetime: '2023-07-31',
                inquiryType: 'inquiryType',
                inquiryTitle: 'inquiryTitle',
                inquiryContents01: 'inquiryContents01',
                inquiryContents02: 'inquiryContents02',
                inquiryContents03: 'inquiryContents03',
                inquiryProcStatus: 1,
            };
            const response = await propertyUseCase.postListedPropertyInquiriesCreate(data);
            // openSuccessNoti();
            dispatch(setVisibleCU02902());
            if (response && response.status == '200') {
                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const checkForm = () => {
        if (
            form.getFieldValue('propertyName')?.trim().length > 0 &&
            form.getFieldValue('residence')?.trim().length > 0
        ) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-050-01-container CU-001-04-container CU-029-02-container pr-40"
        >
            <ModalRegisterProperty
                title="物件の登録依頼を受け付けました"
                description={LIST_CONTENT_POPUP}
            />
            <PageTitle title="くわしく査定" />
            <Form
                form={form}
                className="width-full-screen CU-001-04-container"
                style={{
                    height: '100vh',
                }}
                onFinish={showConfirmModal}
                onValuesChange={() => checkForm()}
            >
                <div style={{ width: '100%' }}>
                    <div className="title-page" style={{ marginBottom: 16 }}>
                        物件登録問い合わせ
                    </div>
                    <section style={{ width: '100%' }}>
                        <div style={{ marginBottom: 12 }} className="label-form-item">
                            物件名
                        </div>
                        <Form.Item
                            rules={[
                                {
                                    whitespace: true,
                                    message: '物件名を入力してください。',
                                },
                            ]}
                            className="input-font-style label-form-style "
                            name="propertyName"
                            label={false}
                        >
                            <Input
                                maxLength={100}
                                style={{ width: '100%' }}
                                placeholder={PLACEHOLDER.PROPERTY_NAME}
                                onBlur={() => {
                                    commonHelpers.onBlurTrimFormItem(form, 'propertyName');
                                }}
                                autoComplete="off"
                            />
                        </Form.Item>
                        <div style={{ marginBottom: 12 }} className="label-form-item">
                            住所
                        </div>
                        <Form.Item
                            rules={[
                                {
                                    whitespace: true,
                                    message: '住所を入力してください。',
                                },
                            ]}
                            className="input-font-style label-form-style "
                            name="residence"
                            label={false}
                        >
                            <Input
                                maxLength={100}
                                style={{ width: '100%' }}
                                placeholder={PLACEHOLDER.ADDRESS}
                                onBlur={() => {
                                    commonHelpers.onBlurTrimFormItem(form, 'residence');
                                }}
                                autoComplete="off"
                            />
                        </Form.Item>
                    </section>

                    <Button
                        className="button-login-text"
                        type="primary"
                        style={{ width: '100%', height: 56 }}
                        disabled={isDisabled}
                        htmlType="submit"
                    >
                        登録を依頼する
                    </Button>
                </div>
            </Form>
        </div>
    );
};
export default CU02902Page;
